<template>
  <v-menu full-width>
    <template #activator="{ props }">        
      <MenuBtn v-bind="props" :label="$tt(`home_page.overview_menu_label_${mobile ? 'mobile' : 'desktop'}`)" />
    </template>
    <v-list>
      <AppListItem
        v-for="country in $branch.visaCountries"
        :to="getVisaCountryPath(country)"
      >
        <CountryFlag :code="getVisaCountryIsoCode(country)" start />
        <span>{{ tCountry(getVisaCountryIsoCode(country)) }}</span>
      </AppListItem>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import { getVisaCountryIsoCode, getVisaCountryPath } from '~/helpers/visa-country';
import type { CountryKey } from '~/types';

defineEmits<{
  select: [CountryKey];
}>();

const { tCountry } = useLocalization();
const { mobile } = useBreakpoints();
</script>